import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageService } from './localstorage.service';

export interface ShipmentStatistics {
  envios: {
    aguardandoEntrega: number;
    entregueComAtraso: number;
    entregueDentroPrazo: number;
    outros: number;
    clienteId?: number;
    periodo?: {
      inicio?: Date | string;
      fim?: Date | string;
    };
  };
}

@Injectable()
export class ChartsService {
  constructor(private http: HttpClient, private lss: LocalStorageService) {}

  get(id: number, data: { [key: string]: string }): Observable<ShipmentStatistics> {
    return this.http.get<ShipmentStatistics>(`${environment.angularJSconstants.URLAPICLIENTE}/clientes/${id}/estatisticas/envios`, {
      headers: {
        'Authorization': this.lss.get('token'),
      },
      params: data
    });
  }
}
